<script>
	import { onMount } from 'svelte';
	// vercel analytics
	import { track } from '@vercel/analytics';
	import { toolsInfoObjects } from '$lib/data/tools';

	let tools = toolsInfoObjects({filterHidden: true});

	onMount(async () => {
		track('page.viewed', { page: 'about/features' });
	});
</script>
<svelte:head>
	<title>🧰 Tools</title>
</svelte:head>
<style>
	header, .center {
		text-align: center;
	}
</style>
<div class="pico">
	<br />
    <article>
		<header>
			<hgroup>
				<h1>🧰 Tools</h1>
				<p>
					Tools are actions that the TeamTeacher agent can take to accomplish a goal, including searching knowledge bases and creating documents.
				</p>
			</hgroup>
		</header>
        <section>
			<div class="grid" style="
				display: grid;
				grid-template-columns: repeat(3, 1fr);
				gap: 1rem;">
				{#each tools as tool}
					<div class="grid-item" style="border: 1px solid #ccc;
					padding: 1rem;
					border-radius: 8px;">
						<br />
						<h2 style="text-align: center;">
							
							{tool.name}
						</h2>
						<h4 class="center">{tool.description}</h4>
						<p>{tool.about}</p>
					</div>
				{/each}
			</div>
        </section>
    </article>
</div>
